// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsConditionAdd_wrapper__IzoSC","heading":"TermsConditionAdd_heading__gfBtF","formContainer":"TermsConditionAdd_formContainer__LAMKr"};